



































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import { Notify, Dialog } from 'vant'
export default Vue.extend({
    data() {
        return {
            loading: false,
            pageNum: 1,
            pageSize: 3,
            total: 0,
            list: [] as any[],
            imgBaseUrl: config.imgUrl,
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.loading = true
            const { pageNum, pageSize } = this
            const params = { pageNum, pageSize, type: 1 }
            const url = `/api/farming/rest_product/page`
            request.get(url, params).then((result) => {
                if (result) {
                    // console.log(result)
                    if (pageNum === 1) {
                        this.list = result.list
                    } else {
                        this.list = this.list.concat(result.list)
                    }
                    this.list.map((e: any) => {
                        e.time = moment(e.createTime).format('YYYY/MM/DD')
                    })
                    this.total = result.total
                    this.loading = false
                }
            }).catch((err) => {
                this.loading = false
                console.log(err)
                this.$Message.warning(err)
            })
        },
        onLoad() {
            this.pageNum += 1
            this.getData()
        },
        showDetails(item: any) {
            this.$router.push({
                path: `/details_view/${item.id}`,
                // query: {
                //     id: item.id
                // },
            })
        },
    },
})
